import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    // Vérification synchrone uniquement (pas d'appel API)
    // isAuthenticated() vérifie uniquement les tokens locaux, pas la validité côté serveur
    const isAuth = authService.isAuthenticated();
    
    if (isAuth) {
      // User is already logged in, redirect according to category and roles
      const defaultRoute = authService.getDefaultRoute();
      router.navigate([defaultRoute]).catch(err => {
        console.error('❌ Navigation error in loginGuard:', err);
      });
      return false;
    }
  } catch (error) {
    // En cas d'erreur, permettre l'accès à la page de login
    console.warn('⚠️ LoginGuard error, allowing access to login page:', error);
    return true;
  }

  return true;
};

